"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeIntervalEnum = void 0;
var TimeIntervalEnum;
(function (TimeIntervalEnum) {
    TimeIntervalEnum["YTD"] = "YTD";
    TimeIntervalEnum["MONTHS3"] = "MONTHS3";
    TimeIntervalEnum["MONTHS6"] = "MONTHS6";
    TimeIntervalEnum["YEARS1"] = "YEARS1";
    TimeIntervalEnum["YEARS3"] = "YEARS3";
    TimeIntervalEnum["YEARS5"] = "YEARS5";
    TimeIntervalEnum["SINCE_INCEPTION"] = "since-inception";
})(TimeIntervalEnum = exports.TimeIntervalEnum || (exports.TimeIntervalEnum = {}));
//# sourceMappingURL=index.js.map